export function randomId({prefix, suffix, min, max, entropy}){

    if( typeof prefix === "undefined" ) prefix = '_id';
    if( typeof suffix === "undefined" ) suffix = '';
    if( typeof min === "undefined" ) min = 100000;
    if( typeof max === "undefined" ) max = 9999999999;
    if( typeof entropy === "undefined" ) entropy = true;

    if( entropy ){
        prefix += '_e' + (new Date().getTime());
        if( typeof typeof window.performance !== 'undefined' && typeof window.performance.now !== 'undefined' ){
            prefix += 'x' + Math.ceil( window.performance.now() * 10000000000000 );
        }
    }

    return prefix + '_r' + random(100000, 999999999).toString() + suffix;
}

export function random(min, max){
    min = Math.ceil(min);
    max = Math.floor(max + 1);
    return Math.floor(Math.random() * (max - min) + min); //Both maximum & minimum are inclusive
}

export function randomColor(min_luminosity = 10, max_luminosity = 60){
    return hslToHex(random(0, 360), random(30, 100), random(min_luminosity, max_luminosity));
}


export function hslToHex(h, s, l) {
    l /= 100;
    const a = s * Math.min(l, 1 - l) / 100;
    const f = n => {
        const k = (n + h / 30) % 12;
        const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
        return Math.round(255 * color).toString(16).padStart(2, '0');   // convert to Hex and prefix "0" if needed
    };
    return `#${f(0)}${f(8)}${f(4)}`;
}

export function array_fill_with_objects(keys, objects, key = 'id') {
    const filled_array = [];
    for (const i in keys){
        if( !keys.hasOwnProperty(i) ) continue;
        const found = objects.filter( obj => obj[ key ] === keys[ i ] );
        if( found.length ){
            filled_array.push( found.shift() );
        }
    }
    return filled_array;
}

export function nl2br(text){
  text = `${text}`;
  return text.split("\n").join("<br>")
}

export function initials(str){
    str = `${str}`;
    return str.split(' ').map( s => s.substr(0, 1) ).join('').substr(0, 2)
}

export function errors(array, type){
    return array.reduce((prev, val) => ((typeof val[type] !== 'undefined' ? prev.push( val[type] ) : 0), prev), []);
}

export function slugify(str, sep = '-'){
    str = `${str}`;
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    const from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
    const to   = "aaaaaeeeeeiiiiooooouuuunc------";
    for (let i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, sep) // collapse whitespace and replace by -
        .replace(/-+/g, sep); // collapse dashes

    return str;
}
export function ellipsis(str, left = 15, right = 15){
    str = `${str}`;
    if( str.length < (left + right + 3) ) return str;
    return str.substr(0, left) + '...' + str.substr(str.length - right);
}

export function excerpt(str, max_length = 30, ellipsis = '...'){
    str = `${str}`;
    if( str.length <= max_length ) return str;
    return str.substr(0, (max_length - ellipsis.length)) + ellipsis;
}

export function ucwords(str){
    str = `${str}`;
    return str.split(' ').map( s => s.substr(0, 1).toUpperCase() + s.substr(1) ).join(' ');
}


export function titleize(str){
    return ucwords( str.replace(/[^a-zA-Z0-9]+/g, ' ') );
}

export function textToTimestamp(str){
    str = `${str}`;
    return str.split(':')
        .reverse()
        .reduce((prev, val, idx) => prev + val * (idx > 0 ? 60 : 1), 0);
}

export function timestampToText(timestamp){
    timestamp = Math.round( timestamp );
    const secs = timestamp % 60;
    const mins = Math.floor(timestamp / 60);
    return `${mins}:${secs <= 9 ? `0${secs}` : secs}`;
}


export function colorBrightness(color, amount){
    let usePound = false;

    if (color[0] === "#") {
        color = color.slice(1);
        usePound = true;
    }

    const num = parseInt(color, 16);

    let r = (num >> 16) + amount;

    if (r > 255) r = 255;
    else if  (r < 0) r = 0;

    let b = ((num >> 8) & 0x00FF) + amount;

    if (b > 255) b = 255;
    else if  (b < 0) b = 0;

    let g = (num & 0x0000FF) + amount;

    if (g > 255) g = 255;
    else if (g < 0) g = 0;

    return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);

}

// Cache is added to process color faster in run-time.
const colorBrightness2Cache = {};
const colorSaturationCache = {};


/* accepts parameters
 * r  Object = {r:x, g:y, b:z}
 * OR
 * r, g, b
*/
function RGBtoHSV(r, g, b) {
    if (arguments.length === 1) {
        g = r.g, b = r.b, r = r.r;
    }
    let max = Math.max(r, g, b), min = Math.min(r, g, b),
        d = max - min,
        h,
        s = (max === 0 ? 0 : d / max),
        v = max / 255;

    switch (max) {
        case min: h = 0; break;
        case r: h = (g - b) + d * (g < b ? 6: 0); h /= 6 * d; break;
        case g: h = (b - r) + d * 2; h /= 6 * d; break;
        case b: h = (r - g) + d * 4; h /= 6 * d; break;
    }

    return {
        h: h,
        s: s,
        v: v
    };
}


/* accepts parameters
 * h  Object = {h:x, s:y, v:z}
 * OR
 * h, s, v
*/
function HSVtoRGB(h, s, v) {
    let r, g, b, i, f, p, q, t;
    if (arguments.length === 1) {
        s = h.s, v = h.v, h = h.h;
    }
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);
    switch (i % 6) {
        case 0: r = v, g = t, b = p; break;
        case 1: r = q, g = v, b = p; break;
        case 2: r = p, g = v, b = t; break;
        case 3: r = p, g = q, b = v; break;
        case 4: r = t, g = p, b = v; break;
        case 5: r = v, g = p, b = q; break;
    }
    return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255)
    };
}



/* accepts parameters
 * r  Object = {r:x, g:y, b:z}
 * OR
 * r, g, b
*/
function RGBtoHEXRGB(r, g, b) {
    if (arguments.length === 1) {
        r = r.s, g = r.v, b = r.h;
    }
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}




export function colorBrightness2(hex, percent){
    // strip the leading # if it's there

    hex = hex.replace(/^\s*#|\s*$/g, '');

    const key = `${hex}|${percent}`;

    if( typeof colorBrightness2Cache[ key ] !== 'undefined' ){
        return colorBrightness2Cache[ key ];
    }

    // convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
    if(hex.length === 3){
        hex = hex.replace(/(.)/g, '$1$1');
    }

    const r = parseInt(hex.slice(0, 2), 16),
          g = parseInt(hex.slice(2, 4), 16),
          b = parseInt(hex.slice(4, 6), 16);

    const hsv = RGBtoHSV(r, g, b);

    hsv.v += percent / 100;
    hsv.v = hsv.v > 1 ? 1 : (hsv.v < 0 ? 0 : hsv.v);
    const rgb = HSVtoRGB( hsv );

    colorBrightness2Cache[ key ] = `rgb(${rgb.r},${rgb.g},${rgb.b})`;
    return colorBrightness2Cache[ key ];

}

export function colorSaturation(hex, percent){
    // strip the leading # if it's there

    hex = hex.replace(/^\s*#|\s*$/g, '');

    const key = `${hex}|${percent}`;

    if( typeof colorSaturationCache[ key ] !== 'undefined' ){
        return colorSaturationCache[ key ];
    }

    // convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
    if(hex.length === 3){
        hex = hex.replace(/(.)/g, '$1$1');
    }

    const r = parseInt(hex.slice(0, 2), 16),
          g = parseInt(hex.slice(2, 4), 16),
          b = parseInt(hex.slice(4, 6), 16);

    const hsv = RGBtoHSV(r, g, b);
    hsv.s += 1 / percent;
    hsv.s = hsv.s > 1 ? 1 : (hsv.s < 0 ? 0 : hsv.s);

    colorSaturationCache[ key ] = RGBtoHEXRGB( HSVtoRGB( hsv ) );
    return colorSaturationCache[ key ];

}


/**
 *
 * @param {Array|Object} val
 * @param {int} max_depth
 * @returns {{}}
 */
export function flatten(val, max_depth = 2){

    // console.log({val});
    // return;

    // The object which contains the
    // final result
    let result = {};

    if( max_depth <= -1 ) return result;

    // loop through the object "ob"
    for (const i in val) {

        // We check the type of the i using
        // typeof() function and recursively
        // call the function again
        if (val[i] && ( (typeof val[i]) === 'object' || Array.isArray(val[i]) )) {
            const temp = flatten(val[i], max_depth - 1);
            for (const j in temp) {
                result[i + '.' + j] = temp[j];
            }

        }else {
            result[i] = val[i];
        }
    }
    return result;
}

export default {
    randomId, random, hslToHex, nl2br, initials, textToTimestamp, timestampToText, array_fill_with_objects,
    randomColor, colorBrightness, colorBrightness2, colorSaturation, errors, ellipsis, ucwords, excerpt, titleize,
    slugify, flatten,
};
